// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:55:27

export default {
  "id": "cleaning-princess",
  "slug": "cleaning-princess",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7b3c15df3b4f4088b5f47ac068672117-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7b3c15df3b4f4088b5f47ac068672117/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cleaning Princess",
      "description": "This is an ASMR game for girls. If you like to clean everything, our game is right for you. The game has 5 modes: ear cleaning, heel cleaning, back spa, teeth cleaning, and fan cleaning. You can use different tools to clean and massage your body parts. But it is important to note that each mode has a countdown time and you must choose the right tool to do the cleaning.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Care",
        "Casual"
      ],
      "tags": [
        "cleaning",
        "girls",
        "spa"
      ]
    },
    "zh-CN": {
      "title": "清理公主",
      "description": "这是一款专为女孩设计的ASMR游戏。如果你喜欢清洁一切，我们的游戏非常适合你。游戏包含5种模式：耳部清洁、脚跟清洁、背部按摩、牙齿清洁和风扇清洁。你可以使用不同的工具清洁和按摩身体部位。但请注意，每种模式都有倒计时时间，你必须选择正确的工具进行清洁。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "关怀",
        "休闲"
      ],
      "tags": [
        "清洁",
        "女孩",
        "水疗"
      ]
    },
    "zh-TW": {
      "title": "清潔公主",
      "description": "這是一款為女孩設計的ASMR遊戲。如果你喜歡清潔一切，我們的遊戲正是你需要的。遊戲有5種模式：耳朵清潔、腳跟清潔、背部按摩、牙齒清潔和扇子清潔。你可以使用不同的工具來清潔和按摩身體各部位。但重要的是要注意，每種模式都有倒計時時間，你必须選擇正確的工具來進行清潔。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "關心",
        "隨意"
      ],
      "tags": [
        "清潔",
        "女孩",
        "水療"
      ]
    },
    "zh-HK": {
      "title": "清潔公主",
      "description": "這是一款為女生設計的ASMR遊戲。如果你喜歡清潔一切，我們的遊戲正是適合你。遊戲有5種模式：耳垢清潔、腳跟清潔、背部SPA、牙齒清潔及風扇清潔。你可以使用不同的工具來清潔和按摩身體部位。但重要的是要注意，每種模式都有倒計時時間，你必須選擇正確的工具來進行清潔。",
      "instructions": "滑鼠點擊或輕觸遊玩",
      "genres": [
        "關心",
        "隨意"
      ],
      "tags": [
        "清潔",
        "女兒",
        "水療"
      ]
    },
    "ja": {
      "title": "お姫様の掃除",
      "description": "これは少女向けのASMRゲームです。全てをきれいに整えたい方にお勧めです。ゲームには5つのモードがあります：耳掃除、踵掃除、背部スパ、歯の掃除、ファン掃除。体の部位を清掃しマッサージするための異なるツールを使用できます。ただし、各モードにはカウントダウン時間があり、適切なツールを選択する必要があります。",
      "instructions": "マウスクリックまたはタップしてゲームを始めましょう",
      "genres": [
        "ケア",
        "カジュアル"
      ],
      "tags": [
        "掃除",
        "女子",
        "スパ"
      ]
    },
    "ko": {
      "title": "공주 청소",
      "description": "이는 여성용 ASMR 게임입니다. 모든 것을 청소하는 것을 좋아한다면, 우리의 게임은 당신에게 적합합니다. 게임에는 5가지 모드가 있습니다: 귀 청소, 발끝 청소, 등 스파, 치아 청소, 그리고 팬 청소. 다양한 도구를 사용하여 몸 부분을 청소하고 마사지할 수 있습니다. 하지만 각 모드에는 카운트다운 시간이 있으며, 청소를 위해 적절한 도구를 선택해야 합니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "주의",
        "캐주얼"
      ],
      "tags": [
        "청소",
        "여자",
        "스파"
      ]
    },
    "fr": {
      "title": "Nettoyer la Princesse",
      "description": "C'est un jeu ASMR pour les filles. Si vous aimez nettoyer tout, notre jeu est fait pour vous. Le jeu comporte 5 modes : nettoyage des oreilles, nettoyage des talons, spa du dos, nettoyage des dents et nettoyage des ventilateurs. Vous pouvez utiliser différents outils pour nettoyer et masser vos parties du corps. Mais il est important de noter que chaque mode a un décompte de temps et que vous devez choisir l'outil approprié pour le nettoyage.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Prudence",
        "Occasionnel"
      ],
      "tags": [
        "nettoyage",
        "filles",
        "spa"
      ]
    }
  }
};
